import { createAction, props } from "@ngrx/store";
import { EAuthClientsResponse } from "../models/EAuthClients";

export const loadEAuthClients = createAction(
    '[eAuthorization Page - eAuth Table] Load eAuth Clients',
    props<{ accountId: string }>()
);

export const loadEAuthClientsSuccess = createAction(
    '[eAuthorization Page - eAuth Table] eAuth Clients Loaded Successfully',
    props<{response: EAuthClientsResponse}>()
);

export const loadEAuthClientsFailure = createAction(
    '[eAuthorization Page - eAuth Table] eAuth Clients NOT Loaded',
    props<{ errorMsg: string}>()
);

export const loadCreateStandingAuthEAuthClients = createAction(
    '[eAuthorization Page - eAuth Table] Load create Standing Authorization eAuth Clients',
    props<{ accountId: string }>()
);

export const loadCreateStandingAuthEAuthClientsSuccess = createAction(
    '[eAuthorization Page - eAuth Table] Create Standing Authorization eAuth Clients Loaded Successfully',
    props<{response: EAuthClientsResponse}>()
);

export const loadCreateStandingAuthEAuthClientsFailure = createAction(
    '[eAuthorization Page - eAuth Table] Create Standing Authorization eAuth Clients NOT Loaded',
    props<{ errorMsg: string}>()
);

export const submitEmailClicked = createAction(
    '[eAuth Table] Submit email clicked',
    props<{ accountId: string, customerId: string, emailAddress: string }>()
);

export const submitEmailSuccess = createAction(
    '[eAuth Table] Submitted email address successfully',
    props<{ customerId: string }>()
);

export const submitEmailFailure = createAction(
    '[eAuth Table] Failed to submit email address',
    props<{ errorMsg: any}>()
);

export const submitEmailFailureNullResponse = createAction(
    '[eAuth Table] Failed to submit email address - Received null response'
);